import { lazy } from 'react'

const NotFound = lazy(() => import('@/pages/404'));

const GpuCloud = lazy(() => import('@/pages/gpuCloud/gpuCloud'));
const LoginPage = lazy(() => import('@/pages/login'));
const Register = lazy(() => import('@/pages/login/register'));
const ResetPage = lazy(() => import('@/pages/login/reset'));
const Terms = lazy(() => import('@/pages/terms/terms'));
const Pricing = lazy(() => import('@/pages/pricing/pricing'));

const RunpodPods = lazy(() => import('@/pages/runpod/pods'));
const GpuSelection = lazy(() => import('@/pages/runpod/gpuSelection'));
const GpuConfig = lazy(() => import('@/pages/runpod/gpuConfig'));
const CpuSelection = lazy(() => import('@/pages/runpod/cpuSelection'));
const CpuConfig = lazy(() => import('@/pages/runpod/cpuConfig'));
const Billing = lazy(() => import('@/pages/billing/billing'));
const GiftCards = lazy(() => import('@/pages/giftCards/giftCards'));
const UserCenter = lazy(() => import('@/pages/user/user'));
const Security = lazy(() => import('@/pages/user/security'));
const SshKeys = lazy(() => import('@/pages/user/sshKeys'));
const Support = lazy(() => import('@/pages/support/support'));
const TicketDetail = lazy(() => import('@/pages/support/ticketDetail'));
const NetworkVolumes = lazy(() => import('@/pages/storage/networkVolumes'));
const CreateVolume = lazy(() => import('@/pages/storage/createVolume'));
const WebTerminal = lazy(() => import('@/pages/terminal/terminal'));
const AuditLogs = lazy(() => import('@/pages/audit/auditLogs'));

const AdminDashboard = lazy(() => import('@/pages/dashboard/dashboard'));
const AdminGpuPricing = lazy(() => import('@/pages/dashboard/gpuPricing'));
const AdminCpuPricing = lazy(() => import('@/pages/dashboard/cpuPricing'));
const AdminUsers = lazy(() => import('@/pages/dashboard/users'));
const AdminPods = lazy(() => import('@/pages/dashboard/pods'));
const AdminTickets = lazy(() => import('@/pages/dashboard/tickets'));
const AdminArticles = lazy(() => import('@/pages/dashboard/articles'));
const AdminArticleDetail = lazy(() => import('@/pages/dashboard/articleDetail'));
const AdminPaypal = lazy(() => import('@/pages/dashboard/paypal'));
const AdminCreditCards = lazy(() => import('@/pages/dashboard/creditCards'));

export interface RouteConfig {
	path: string
	component?: React.LazyExoticComponent<React.ComponentType<any>>
	redirectTo?: string
	name?: string
	exact?: boolean
	requireAuth?: boolean
	requireAdmin?: boolean
}

const routers: RouteConfig[] = [
	{
		path: '/',
		exact: true,
		component: GpuCloud,
		name: 'Home'
	},
	{
		path: '/index',
		redirectTo: '/',
		name: 'Index',
	},
	{
		path: '/404',
		component: NotFound,
	},
	{
		path: '/signin',
		component: LoginPage,
		name: 'SignIn'
	},
	{
		path: '/signup',
		component: Register,
		name: 'SignUp'
	},
	{
		path: '/reset',
		component: ResetPage,
		name: 'Reset'
	},
	{
		path: '/terms',
		component: Terms,
		name: 'Terms'
	},
	{
		path: '/pricing',
		component: Pricing,
		name: 'Pricing'
	},
	{
		path: '/console/compute/pods',
		component: RunpodPods,
		requireAuth: true
	},
	{
		path: '/console/compute/gpu-selection',
		component: GpuSelection,
		requireAuth: true
	},
	{
		path: '/console/compute/gpu-config',
		component: GpuConfig,
		requireAuth: true
	},
	{
		path: '/console/compute/cpu-selection',
		component: CpuSelection,
		requireAuth: true
	},
	{
		path: '/console/compute/cpu-config',
		component: CpuConfig,
		requireAuth: true
	},
	{
		path: '/console/user',
		component: UserCenter,
		name: 'UserCenter',
		requireAuth: true
	},
	{
		path: '/console/security',
		component: Security,
		requireAuth: true
	},
	{
		path: '/console/ssh-keys',
		component: SshKeys,
		exact: true,
		requireAuth: true
	},
	{
		path: '/console/billing',
		component: Billing,
		requireAuth: true
	},
	{
		path: '/console/gift-cards',
		component: GiftCards,
		requireAuth: true
	},
	{
		path: '/console/support',
		component: Support,
		exact: true,
		requireAuth: true
	},
	{
		path: '/console/support/:id',
		component: TicketDetail,
		requireAuth: true
	},
	{
		path: '/console/storage/network-volumes',
		component: NetworkVolumes,
		requireAuth: true
	},
	{
		path: '/console/storage/create-volume',
		component: CreateVolume,
		requireAuth: true
	},
	{
		path: '/console/terminal',
		component: WebTerminal,
		name: 'Terminal',
		requireAuth: true
	},
	{
		path: '/console/audit-logs',
		component: AuditLogs,
		name: 'AuditLogs',
		requireAuth: true
	},
	{
		path: '/dashboard',
		component: AdminDashboard,
		exact: true,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/gpu-pricing',
		component: AdminGpuPricing,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/cpu-pricing',
		component: AdminCpuPricing,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/users',
		component: AdminUsers,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/pods',
		component: AdminPods,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/tickets',
		component: AdminTickets,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/articles',
		component: AdminArticles,
		exact: true,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/articles/:id',
		component: AdminArticleDetail,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/paypal',
		component: AdminPaypal,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/credit-cards',
		component: AdminCreditCards,
		requireAuth: true,
		requireAdmin: true
	}
]

export default routers